import initialState from '../store/initial-state'
import {
  ASSET_ROOT_UPLOAD_GET_DATA,
  ASSET_ROOT_UPLOAD_GET_DATA_SUCCESS,
  ASSET_ROOT_UPLOAD_GET_DATA_FAILURE,
} from '../constants/assets-root-upload-types'

export default (state = initialState.assetsRootUpload, action) => {
  switch (action.type) {
    case ASSET_ROOT_UPLOAD_GET_DATA:
      return {
        ...state,
        isFetching: action.payload.isFetching,
        data: action.payload.data,
        // isFetching: true,
        // data: [],
        headers: null,
        error: null
      }

    case ASSET_ROOT_UPLOAD_GET_DATA_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.user.clientRole === 'admin' || action.payload.user.role === 'admin'
          ? action.payload.data
          : action.payload.data.filter(r => r.group.length > 0),
        headers: action.payload.headers,
        folderselect: action.payload.folderselect,
        error: null
      }

    case ASSET_ROOT_UPLOAD_GET_DATA_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        headers: null,
        error: action.payload
      }

    default: return { ...state }
  }
}